import { isSafari } from 'react-device-detect'

export const selectCurrentTarget = (
  event?:
    | React.FocusEvent<HTMLInputElement>
    | React.FormEvent<HTMLInputElement>,
): void => {
  if (!event) return
  const input = event.currentTarget as HTMLInputElement
  if (isSafari) {
    /* currentTarget.select() doesn't work on Safari */
    try {
      input.focus()
      input.setSelectionRange(0, input.value.length)
    } catch (ex) {
      console.log(ex)
      /* Set selection error - usually for chrome in iPad debug mode */
      input.select()
    }
  } else {
    input.select()
  }
}
